import { Box } from '@chakra-ui/react';
import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { PlaybookList } from '@src/components/sco/Education/PlaybookList';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { EducationPage } from '@src/templates/EducationPage';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page(props) {
  const layout = useParentAppLayout();
  const educationContext = useEducationContext();
  const activeContent = useActiveContentContext();
  useUniversalEffect(() => {
    layout.updatePanel('edu-aside', {
      isPanelOpen: false
    });
    educationContext.setActiveSection('playbooks.landing');
    educationContext.setBreadcrumbs([{
      title: 'Playbooks',
      href: '/playbooks'
    }]);
  }, []);
  return <Box padding={'2em'}>
      <PlaybookList />
    </Box>;
});